
import Vue from 'vue';
import { Runnit, RunnitMember, TeamMember } from '@run-diffusion/shared';
import { get$bindFirestoreOptions } from '@/mixins';
import { db, Query } from '@/firebase';
import { formatTruncatedEmailForChip } from '@/utils/utils';

export default Vue.extend({
	name: 'RunnitBoardMemberChip',
	props: {
		runnitMember: {
			type: Object as () => RunnitMember,
			required: true,
		},
		runnit: {
			type: Object as () => Runnit,
			required: true,
		},
	},
	data () {
		return {
			teamMembers: [] as TeamMember[],
			loading: false,
		};
	},
	computed: {
		teamMember (): TeamMember | null {
			return this.teamMembers[0] || null;
		},
	},
	watch: {
		runnitMember: {
			immediate: true,
			handler (newVal: RunnitMember, oldVal: RunnitMember) {
				const newUserId: string = newVal?.userId;
				const oldUserId: string = oldVal?.userId;
				if (newUserId !== oldUserId) {
					this.loadTeamMember(newUserId, this.runnit?.teamId);
				}
			},
		},
		runnit: {
			immediate: true,
			handler (newVal: Runnit, oldVal: Runnit) {
				const newTeamId: string = newVal?.teamId;
				const oldTeamId: string = oldVal?.teamId;
				if (newTeamId !== oldTeamId) {
					this.loadTeamMember(this.runnitMember?.userId, newTeamId);
				}
			},
		},
	},
	methods: {
		formatTruncatedEmailForChip,
		async loadTeamMember (userId: string, teamId: string) {
			if (!teamId || !userId) {
				this.teamMembers = [];
				return;
			}

			this.loading = true;
			try {
				const teamMemberRef: Query = db.collection(`teams/${teamId}/teamMembers`)
					.where('userId', '==', userId)
					.limit(1);

				await this.$bind(
					'teamMembers',
					teamMemberRef,
					get$bindFirestoreOptions(),
				);
			} catch (error) {
				console.error('Error binding team member:', error);
			} finally {
				this.loading = false;
			}
		},
	},
});
